//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SmartObject.js";
import "../no/ugmath.js";
let d=[[[0,"Vector",1,0]],[[[],"ReverseDirection",{R_:{success:''}},0,0]],[]];
SPLM.Offset = class extends SPLM.SmartObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Offset";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Offset.OnFaceOption = Object.freeze({
    "U" : "U", "V" : "V", "Section" : "Section"});

export default SPLM;